import { makeStyles } from '@material-ui/core';

import { SignUpImg } from 'assets/index';

export default makeStyles((theme) => ({
  rightContent: {
    width: '50%',
    minHeight: '100vh',
    '@media (max-width: 767px)': {
      display: 'none',
      opacity: 0,
    },
  },
  rightImg: {
    position: 'relative',
    backgroundImage: `url('${SignUpImg}')`,
    backgroundRepeat: 'no-repeat',
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  acceleratorText: {
    position: 'absolute',
    top: 'calc(50% - 50px)',
    padding: 30,
    textAlign: 'center',
    left: 0,
    right: 0,
  },
  acceText: {
    fontSize: 29,
    fontWeight: 800,
    color: theme.palette.primary.contrastText,
    marginBottom: 15,
  },
}));
